import React, { Component } from 'react';

import Icon from '../../components/common/Icon';

import appStore from '../../../images/content/app-store.svg';
import googlePlay from '../../../images/content/google-play.svg';
// import appgallery from "../../../images/content/app-gallery.svg";
import loadapk from "../../../images/content/load-apk.svg";
import ruStore from "../../../images/content/ru-store.svg";
import PropTypes from "prop-types";
import LinkC from "../../components/common/LinkC";
import {mainUrl} from "../../tools/config";

class Footer extends Component {

    static contextTypes = {
        selectedRegion:  PropTypes.object,
        fetchBefore: PropTypes.func,
        isLk: PropTypes.bool
    };

    render() {

        let footerObj = this.props.footerMenuList.filter(x => x.regionId === this.context.selectedRegion.id);
        let regionAlias = this.context.selectedRegion.alias;
        let fetchBefore = this.context.fetchBefore;
        let d = new Date();
        let thisYear = d.getFullYear();

        if (footerObj.length === 0) {
            return (
                <footer className="page__footer">
                </footer>
            )
        }

        return (
            <footer className="page__footer">
                <div className="b-footer b-footer_adapt_default">
                    <div className="b-footer__top-section">
                        <div className="page__container">
                            <div className="b-footer__menu-holder">
                                <div className="b-footer-menu">
                                    <div className="b-footer-menu__holder">
                                        <ul className="b-footer-menu__level">
                                            {footerObj[0].data.map((col, idx) =>
                                                <li className="b-footer-menu__item" key={idx}>
                                                    <div className="b-footer-menu__link-holder">
                                                        <LinkC
                                                            className={"b-footer-menu__link"}
                                                            to={(this.context.isLk && col.link.indexOf('http') !== 0 ? mainUrl+this.context.selectedRegion.alias : "")+col.link}
                                                            targetBlank={col.new_tab == "1"}
                                                        >
                                                            <span className="b-footer-menu__text">{col.title}</span>
                                                        </LinkC>
                                                    </div>
                                                    <div className="b-footer-menu__second-holder">
                                                        <ul className="b-footer-menu__second-level">
                                                            {col.items.map((item, key) =>
                                                                <li className="b-footer-menu__second-item" key={key}>
                                                                    <div className="b-footer-menu__second-link-holder">
                                                                        <LinkC className={"b-footer-menu__second-link"} to={(this.context.isLk && item.link.indexOf('http') !== 0 ? mainUrl+this.context.selectedRegion.alias : "")+item.link} targetBlank={item.new_tab === "1"}>
                                                                            <span className="b-footer-menu__second-text">{item.title}</span>
                                                                        </LinkC>
                                                                    </div>
                                                                </li>
                                                            )}
                                                        </ul>
                                                    </div>
                                                </li>
                                            )}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="b-footer__bottom-section">
                        <div className="page__container">
                            <div className="b-footer__bottom-wrap">
                                <div className="b-footer__copyright-holder">
                                    <div className="b-footer__copyright-text">

                                        <div className="b-footer__copy-text-period">&copy; 2011&ndash;{thisYear}&nbsp;Мотив.
                                        </div>
                                        <div className="b-footer__copy-text-rights">Все права защищены</div>
                                    </div>
                                    <div className="b-footer__copyright-icon">
                                        <Icon name={'icon_18'} className={'b-footer__pg u-icon u-icon_18'} />
                                    </div>
                                </div>

                                <div className={"mobile-apps"}>
                                    <a href="https://motiv.me/appstore" target="_blank">
                                        <img src={ appStore } alt="" role="presentation"/>
                                    </a>
                                    <a href="https://motiv.me/googleplay" target="_blank">
                                        <img src={ googlePlay } alt="" role="presentation"/>
                                    </a>
                                    <a href="https://motiv.me/rustore" target="_blank">
                                        <img src={ ruStore } alt="" role="presentation"/>
                                    </a>
                                    <a href="https://motiv.me/m-app" target="_blank">
                                        <img src={ loadapk } alt="" role="presentation" />
                                    </a>
                                    {/* <a href="https://appgallery.huawei.com/app/C104641419" target="_blank">
                                        <img src={ appgallery } alt="" role="presentation" />
                                    </a> */}
                                </div>
                                <div className="b-footer__developers">
                                    <a href="https://buroburo.ru/" target="_blank" >
                                        <Icon name={'icon_buro'} className={'b-footer__dev-icon u-icon u-icon_buro'} />
                                    </a>
                                </div>
                                <div className="b-footer__socials">
                                    <div className="b-socials b-socials_footer b-socials_adapt_default">
                                        <ul className="b-socials__items">
                                            {/* <li className="b-socials__item">
                                                <a className="b-socials__item-link" href="https://www.facebook.com/motiv4g" target="_blank">
                                                    <Icon name={'icon_facebook'} className={'b-socials__icon u-icon u-icon_facebook'} />
                                                </a>
                                            </li> */}
                                            <li className="b-socials__item">
                                                <a className="b-socials__item-link" href="https://vk.com/motiv4g" target="_blank">
                                                    <Icon name={'icon_vk'} className={'b-socials__icon u-icon u-icon_vk'} />
                                                </a>
                                            </li>
                                            <li className="b-socials__item">
                                                <a className="b-socials__item-link" href="https://www.tiktok.com/@motiv.official" target="_blank">
                                                    <Icon name={'icon_tiktok'} className={'b-socials__icon u-icon u-icon_tiktok'} />
                                                </a>
                                            </li>
                                            {/* <li className="b-socials__item">
                                                <a className="b-socials__item-link" href="https://www.instagram.com/motiv4g/" target="_blank">
                                                    <Icon name={'icon_instagram'} className={'b-socials__icon u-icon u-icon_instagram'} />
                                                </a>
                                            </li> */}
                                            <li className="b-socials__item">
                                                <a className="b-socials__item-link" href="https://www.youtube.com/user/TVMotiv" target="_blank">
                                                    <Icon name={'icon_youtube'} className={'b-socials__icon u-icon u-icon_youtube'} />
                                                </a>
                                            </li>
                                            <li className="b-socials__item">
                                                <a className="b-socials__item-link hover-text-orange" href="https://zen.yandex.ru/id/60ae34e9d0e334758e1315bb" target="_blank">
                                                    {/*<Icon name={'icon_yandex_zen'} className={'b-socials__icon u-icon u-icon_youtube'} />*/}
                                                    <svg className='icon icon_yandex_zen b-socials__icon u-icon u-icon_youtube' width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <g clipPath="url(#clip0_15330_3717)">
                                                            <path d="M8.35 8.35C7.25 9.485 7.17 10.9 7.075 14C9.965 14 11.96 13.99 12.99 12.99C13.99 11.96 14 9.87 14 7.075C10.9 7.175 9.485 7.25 8.35 8.35ZM0 7.075C0 9.87 0.00999999 11.96 1.01 12.99C2.04 13.99 4.035 14 6.925 14C6.825 10.9 6.75 9.485 5.65 8.35C4.515 7.25 3.1 7.17 0 7.075ZM6.925 0C4.04 0 2.04 0.00999999 1.01 1.01C0.00999999 2.04 0 4.13 0 6.925C3.1 6.825 4.515 6.75 5.65 5.65C6.75 4.515 6.83 3.1 6.925 0ZM8.35 5.65C7.25 4.515 7.17 3.1 7.075 0C9.965 0 11.96 0.00999999 12.99 1.01C13.99 2.04 14 4.13 14 6.925C10.9 6.825 9.485 6.75 8.35 5.65Z" fill="currentcolor"/>
                                                            <path d="M14 7.075V6.925C10.9 6.825 9.485 6.75 8.35 5.65C7.25 4.515 7.17 3.1 7.075 0H6.925C6.825 3.1 6.75 4.515 5.65 5.65C4.515 6.75 3.1 6.83 0 6.925V7.075C3.1 7.175 4.515 7.25 5.65 8.35C6.75 9.485 6.83 10.9 6.925 14H7.075C7.175 10.9 7.25 9.485 8.35 8.35C9.485 7.25 10.9 7.17 14 7.075Z" fill="#3B3D3F"/>
                                                        </g>
                                                        <defs>
                                                            <clipPath id="clip0_15330_3717">
                                                                <rect width="14" height="14" fill="currentcolor"/>
                                                            </clipPath>
                                                        </defs>
                                                    </svg>



                                                </a>
                                            </li>
                                            <li className="b-socials__item">
                                                <a className="b-socials__item-link hover-text-orange" href="https://t.me/motiv_ural" target="_blank">
                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className='icon icon_telegram_zen b-socials__icon u-icon'>
                                                        <path d="M4.96243 11.166C8.72052 9.47251 11.2265 8.35607 12.4804 7.81666C16.0604 6.27655 16.8043 6.00901 17.2892 6.00009C17.3958 5.99824 17.6343 6.02557 17.7887 6.1552C17.9192 6.26465 17.955 6.4125 17.9722 6.51628C17.9894 6.62005 18.0108 6.85645 17.9938 7.04116C17.7998 9.14946 16.9603 14.2658 16.5332 16.6271C16.3525 17.6263 15.9967 17.9613 15.6522 17.9941C14.9036 18.0653 14.3351 17.4824 13.6101 16.9908C12.4755 16.2215 11.8345 15.7427 10.7332 14.992C9.46037 14.1245 10.2855 13.6477 11.0108 12.8685C11.2006 12.6646 14.4991 9.56157 14.5629 9.28007C14.5709 9.24487 14.5783 9.11364 14.503 9.04434C14.4276 8.97505 14.3163 8.99874 14.236 9.01759C14.1222 9.0443 12.3097 10.2834 8.7984 12.7349C8.28392 13.1003 7.81791 13.2783 7.40039 13.269C6.9401 13.2587 6.05469 12.9998 5.39648 12.7785C4.58916 12.5071 3.94752 12.3636 4.00339 11.9026C4.03249 11.6625 4.35217 11.417 4.96243 11.166Z" fill="currentcolor"/>
                                                    </svg>


                                                    {/*<Icon name={'icon_telegram_zen'} className={'b-socials__icon u-icon u-icon_telegram'} />*/}
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        )
    }
}

export default Footer;